// const url = 'http://127.0.0.1:8000/api/'

const url = 'https://ed.hetadatain.com/api/'

export default url;